import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../redux/reducer";
import { ToastModel } from "../ToastContainer";
import { toasterActions } from "./model";

export const useToaster = () =>
    useSelector((state: RootState) => state.toaster.toast);

export const useMapPopup = () =>
    useSelector((state: RootState) => state.toaster.mapPopup);

/**
 * @HookTags - toast, success
 */
export const useSuccessToast = () => {
    const dispatch = useDispatch();

    return (
        message: string,
        options?: Pick<ToastModel, "additionalAction">
    ) => {
        return dispatch(toasterActions.success({ message, options }));
    };
};

/**
 * @HookTags - toast, error
 */
export const useErrorToast = () => {
    const dispatch = useDispatch();

    const errorToast = (s: string) => {
        dispatch(toasterActions.error(s));
    };

    return errorToast;
};
